<btn
  htmlType="submit"
  [id]="id || null"
  [icon]="icon"
  [disabled]="isDisabled"
  [loading]="isLoading"
  (click)="onSubmit.emit()"
>
  <ng-content></ng-content>
</btn>

@if (isCancellable) {
<div class="back">
  @if (cancelLink) { or
  <a
    [routerLink]="cancelLink"
    [queryParams]="cancelQueryParams"
    (click)="cancel.emit()"
  >
    {{ cancelLabel }}
  </a>
  } @if (!cancelLink) {
  <a class="active" (click)="cancel.emit()">{{ cancelLabel }}</a>
  }
</div>
}
